const formatPhoneNumber = (phoneNumber) => {
  if (phoneNumber.length === 11 && phoneNumber.charAt(0) === "0") {
    return "+92" + phoneNumber.slice(1);
  }
  return phoneNumber;
};

export default formatPhoneNumber;
